let __kvVeIdInc = 0

export function kvVeId(prefix = "id") {
  __kvVeIdInc += 1
  const rnd = Math.random().toString(36).slice(2, 7)
  return `${prefix}_${Date.now().toString(36)}_${__kvVeIdInc}_${rnd}`
}


